import React, { useEffect, useState } from 'react';
import './Profil.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';

import coinIcon from '../../../images/coin.png';
import boltIcon from '../../../images/bolt.png';

import '../reglaredimensiune.css';
import FriendSuggestions from './social/FriendSuggestions';
import PeopleList from './social/PeopleList';
import AvatarPreview from './avatar/AvatarPreview';
import AvatarEditor from './avatar/AvatarEditor';
import { getAvatarAsset } from './avatar/avatarConfig';

import bazeleconta from '../../../images/bazeleconta.png';
import contafinanciaraone from '../../../images/contafinanciara.png';
import contaprimara from '../../../images/contaprimara.png';
import contabilitateaplicata from '../../../images/contabilitateaplicata.png';
import contiIcon from '../../../images/conti.png';

const courseIcons = {
  1: {
    name: 'Bazele contabilitatii',
    icon: bazeleconta,
  },
  2: {
    name: 'Contabilitate financiara',
    icon: contafinanciaraone,
  },
  3: {
    name: 'Contabilitate primara',
    icon: contaprimara,
  },
  4: {
    name: 'Contabilitate aplicata',
    icon: contabilitateaplicata,
  },
};

const apiUrl = process.env.REACT_APP_API_URL;

const defaultUserAvatar = {
  face: 'asset_face1',
  hair: 'asset_hair',
  clothes: 'tricou',
  glasses: null,
  accessories: null,
  background: 'background_default',
};

const Profil = ({
  onMenuSelect,
  onCogClick,
  onAvatarEditorChange,
  onOpenUser,
}) => {
  const [showPeopleList, setShowPeopleList] = useState(false);

  const [userData, setUserData] = useState(null);

  const [stats, setStats] = useState({
    coins: 0,
    xp: 0,
  });

  const [weeklyRank, setWeeklyRank] = useState(null);
  const [weeklyPoints, setWeeklyPoints] = useState(0);
  const [isWeeklyRankLoading, setIsWeeklyRankLoading] = useState(true);

  const [courseProgress, setCourseProgress] = useState({
    total: 0,
    completed: 0,
    percent: 0,
  });

  const [isCourseProgressLoading, setIsCourseProgressLoading] =
    useState(true);

  const [startedCourses, setStartedCourses] = useState([]);

  // ==============================
  // AVATAR
  // ==============================

  const [showAvatarEditor, setShowAvatarEditor] = useState(false);

  const [userAvatar, setUserAvatar] = useState(defaultUserAvatar);

  const [isSavingAvatar, setIsSavingAvatar] = useState(false);

  // Contoare sociale reale (0 cat timp se incarca)
  const [followCounts, setFollowCounts] = useState({ following: 0, followers: 0 });

  useEffect(() => {
    let cancelled = false;

    const loadFollowCounts = async () => {
      try {
        const [followingRes, followersRes] = await Promise.all([
          fetch(`${apiUrl}/user/following`, { credentials: 'include' }),
          fetch(`${apiUrl}/user/followers`, { credentials: 'include' }),
        ]);

        if (!followingRes.ok || !followersRes.ok) return;

        const [following, followers] = await Promise.all([
          followingRes.json(),
          followersRes.json(),
        ]);

        if (!cancelled) {
          setFollowCounts({
            following: Array.isArray(following) ? following.length : 0,
            followers: Array.isArray(followers) ? followers.length : 0,
          });
        }
      } catch (error) {
        console.error('Eroare la incarcarea contoarelor sociale:', error);
      }
    };

    loadFollowCounts();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    return () => {
      onAvatarEditorChange?.(false);
    };
  }, [onAvatarEditorChange]);

  // ==============================
  // INCARCARE USER
  // ==============================

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await fetch(`${apiUrl}/user`, {
          credentials: 'include',
        });

        if (!res.ok) {
          setUserData(null);

          setStats({
            coins: 0,
            xp: 0,
          });

          return;
        }

        const user = await res.json();

        setUserData(user);

        // ==============================
        // INCARCARE AVATAR DIN DB
        // ==============================

        if (
          user?.avatar_config &&
          typeof user.avatar_config === 'object'
        ) {
          setUserAvatar({
            ...defaultUserAvatar,
            ...user.avatar_config,
          });
        } else {
          setUserAvatar(defaultUserAvatar);
        }

        if (user?.user_id) {
          // ==============================
          // CURSURI INCEPUTE
          // ==============================

          try {
            const startedCoursesRes = await fetch(
              `${apiUrl}/user/started-courses`,
              {
                method: 'GET',
                credentials: 'include',
              }
            );

            if (startedCoursesRes.ok) {
              const startedCoursesData =
                await startedCoursesRes.json();

              setStartedCourses(
                Array.isArray(startedCoursesData)
                  ? startedCoursesData
                  : []
              );
            } else {
              setStartedCourses([]);
            }
          } catch (error) {
            console.error(
              'Eroare cursuri incepute:',
              error
            );

            setStartedCourses([]);
          }

          // ==============================
          // STATISTICI
          // ==============================

          try {
            const statsRes = await fetch(
              `${apiUrl}/user/${user.user_id}/stats`,
              {
                credentials: 'include',
              }
            );

            if (statsRes.ok) {
              const statsData = await statsRes.json();

              setStats({
                coins: Number(statsData?.coins ?? 0),
                xp: Number(statsData?.xp ?? 0),
              });
            } else {
              setStats({
                coins: 0,
                xp: 0,
              });
            }
          } catch (error) {
            console.error(
              'Eroare incarcare statistici:',
              error
            );

            setStats({
              coins: 0,
              xp: 0,
            });
          }

          // ==============================
          // LEADERBOARD
          // ==============================

          try {
            const leaderboardRes = await fetch(
              `${apiUrl}/leaderboard?type=weekly`,
              {
                credentials: 'include',
              }
            );

            if (leaderboardRes.ok) {
              const leaderboard =
                await leaderboardRes.json();

              const userId = Number(user.user_id);

              const currentUserEntry =
                Array.isArray(leaderboard)
                  ? leaderboard.find(
                      (entry) =>
                        Number(entry?.user_id) ===
                        userId
                    )
                  : null;

              const points = Number(
                currentUserEntry?.points ?? 0
              );

              const position = Number(
                currentUserEntry?.position ?? 0
              );

              setWeeklyPoints(points);

              setWeeklyRank(
                points > 0 && position > 0
                  ? position
                  : null
              );
            } else {
              setWeeklyPoints(0);
              setWeeklyRank(null);
            }
          } catch (error) {
            console.error(
              'Eroare leaderboard:',
              error
            );

            setWeeklyPoints(0);
            setWeeklyRank(null);
          } finally {
            setIsWeeklyRankLoading(false);
          }

          // ==============================
          // PROGRES CURS
          // ==============================

          try {
            const [chaptersRes, progressRes] =
              await Promise.all([
                fetch(`${apiUrl}/chapters`, {
                  credentials: 'include',
                }),

                fetch(
                  `${apiUrl}/user/lesson-progress`,
                  {
                    credentials: 'include',
                  }
                ),
              ]);

            if (
              chaptersRes.ok &&
              progressRes.ok
            ) {
              const chaptersData =
                await chaptersRes.json();

              const lessonProgressData =
                await progressRes.json();

              const chapters = Array.isArray(
                chaptersData?.chapters
              )
                ? chaptersData.chapters
                : [];

              const totalLessons =
                chapters.reduce(
                  (total, chapter) =>
                    total +
                    (Array.isArray(
                      chapter?.lessons
                    )
                      ? chapter.lessons.length
                      : 0),
                  0
                );

              const completedLessonKeys =
                new Set(
                  (
                    Array.isArray(
                      lessonProgressData
                    )
                      ? lessonProgressData
                      : []
                  ).map(
                    (entry) =>
                      `${entry.chapter_id}-${entry.lesson_id}`
                  )
                );

              const completedLessons =
                chapters.reduce(
                  (count, chapter) => {
                    const chapterId =
                      chapter?.id;

                    const lessons =
                      Array.isArray(
                        chapter?.lessons
                      )
                        ? chapter.lessons
                        : [];

                    return (
                      count +
                      lessons.reduce(
                        (
                          chapterCount,
                          lesson
                        ) => {
                          const key = `${chapterId}-${lesson.lesson}`;

                          return completedLessonKeys.has(
                            key
                          )
                            ? chapterCount + 1
                            : chapterCount;
                        },
                        0
                      )
                    );
                  },
                  0
                );

              const percent =
                totalLessons > 0
                  ? Math.round(
                      (completedLessons /
                        totalLessons) *
                        100
                    )
                  : 0;

              setCourseProgress({
                total: totalLessons,
                completed:
                  completedLessons,
                percent,
              });
            } else {
              setCourseProgress({
                total: 0,
                completed: 0,
                percent: 0,
              });
            }
          } catch (error) {
            console.error(
              'Eroare progres curs:',
              error
            );

            setCourseProgress({
              total: 0,
              completed: 0,
              percent: 0,
            });
          } finally {
            setIsCourseProgressLoading(false);
          }
        } else {
          setStats({
            coins: 0,
            xp: 0,
          });

          setWeeklyPoints(0);
          setWeeklyRank(null);
          setIsWeeklyRankLoading(false);

          setCourseProgress({
            total: 0,
            completed: 0,
            percent: 0,
          });

          setIsCourseProgressLoading(false);
        }
      } catch (error) {
        console.error(
          'Eroare incarcare profil:',
          error
        );

        setUserData(null);

        setStats({
          coins: 0,
          xp: 0,
        });

        setWeeklyPoints(0);
        setWeeklyRank(null);

        setIsWeeklyRankLoading(false);

        setCourseProgress({
          total: 0,
          completed: 0,
          percent: 0,
        });

        setIsCourseProgressLoading(false);
      }
    };

    fetchUser();
  }, []);

  // ==============================
  // SALVARE AVATAR
  // ==============================

  const handleSaveAvatar = async (
    newAvatar
  ) => {
    if (isSavingAvatar) {
      return;
    }

    try {
      setIsSavingAvatar(true);

      const response = await fetch(
        `${apiUrl}/user/avatar`,
        {
          method: 'PUT',

          credentials: 'include',

          headers: {
            'Content-Type':
              'application/json',
          },

          body: JSON.stringify({
            avatar_config: newAvatar,
          }),
        }
      );

      if (!response.ok) {
        let errorMessage =
          'Avatarul nu a putut fi salvat.';

        try {
          const errorData =
            await response.json();

          if (errorData?.message) {
            errorMessage =
              errorData.message;
          }
        } catch (error) {
          // raspunsul nu este JSON
        }

        throw new Error(errorMessage);
      }

      const data = await response.json();

      console.log(
        'Avatar salvat in baza de date:',
        data
      );

      // Actualizam avatarul local
      setUserAvatar(newAvatar);

      window.dispatchEvent(
  new CustomEvent('avatarUpdated', {
    detail: newAvatar,
  })
);

      // Actualizam si userData local
      setUserData((currentUser) => {
        if (!currentUser) {
          return currentUser;
        }

        return {
          ...currentUser,
          avatar_config: newAvatar,
        };
      });

      // Inchidem editorul
      setShowAvatarEditor(false);

      onAvatarEditorChange?.(false);
    } catch (error) {
      console.error(
        'Eroare salvare avatar:',
        error
      );

      alert(
        'Avatarul nu a putut fi salvat. Incearca din nou.'
      );
    } finally {
      setIsSavingAvatar(false);
    }
  };

  const formattedCoins = Number(
    stats.coins || 0
  ).toLocaleString('ro-RO');

  const formattedXp = Number(
    stats.xp || 0
  ).toLocaleString('ro-RO');

  // ==============================
  // PEOPLE LIST
  // ==============================

if (showPeopleList) {
  return (
    <div className="componentsmenu-container-main">
      <div className="componentsmenu-left-blank"></div>

      <div className="profil-container">
        <PeopleList
          onBack={() =>
            setShowPeopleList(false)
          }
          onOpenProfile={onOpenUser}
        />
      </div>
    </div>
  );
}

  // ==============================
  // AVATAR EDITOR
  // ==============================

  if (showAvatarEditor) {
    return (
      <AvatarEditor
        initialAvatar={userAvatar}
        onBack={() => {
          setShowAvatarEditor(false);
          onAvatarEditorChange?.(false);
        }}
        onSave={handleSaveAvatar}
      />
    );
  }

  // ==============================
  // PROFIL
  // ==============================

  return (
    <div className="componentsmenu-container-main">
      <div className="componentsmenu-left-blank"></div>

      <div className="profil-container">

        <div className="profil-header-bar">
          <span className="profil-header-title">
            Profil
          </span>

          <span
            className="profil-header-cog"
            onClick={() => {
              if (onCogClick) {
                onCogClick();
              } else if (onMenuSelect) {
                onMenuSelect('Setari');
              }
            }}
            style={{
              cursor: 'pointer',
            }}
          >
            <FontAwesomeIcon icon={faCog} />
          </span>
        </div>

        {/* AVATAR */}

   <div
  className="profil-banner"
  style={{
    backgroundColor:
      getAvatarAsset(
        'background',
        userAvatar.background
      )?.color || '#d6f2fe',
  }}
>
  <div className="profil-avatar-wrapper">
    <AvatarPreview
      avatar={userAvatar}
      className="avatar-preview-profile"
    />
  </div>

  <button
    type="button"
    className="profil-avatar-edit-button"
    onClick={() => {
      setShowAvatarEditor(true);
      onAvatarEditorChange?.(true);
    }}
    aria-label="Editeaza avatarul"
  >
    ✎
  </button>
</div>

        {/* USER */}

        <div className="profil-level-box">

          <div className="profil-level-text">

            <h2 className="profil-username">
              {userData?.first_name &&
              userData?.last_name
                ? `${userData.first_name} ${userData.last_name}`
                : userData?.username ||
                  'Utilizator'}
            </h2>

         
<div className="profil-user-handle">
  @{userData?.nickname || 'utilizator'}
</div>


            {userData?.created_at && (
              <div className="profil-joined-date">
                S-a alaturat in{' '}
                {new Date(
                  userData.created_at
                ).toLocaleDateString(
                  'ro-RO',
                  {
                    month: 'long',
                    year: 'numeric',
                  }
                )}
              </div>
            )}

            <div className="profil-follow-row">

              <button
                type="button"
                className="profil-follow-link"
              >
                Urmariti <strong>{followCounts.following}</strong>
              </button>

              <button
                type="button"
                className="profil-follow-link"
              >
                <strong>{followCounts.followers}</strong>{' '}
                urmaritori
              </button>

            </div>

          </div>

          {/* CURSURI INCEPUTE */}

          <div className="profil-started-courses">

            {startedCourses.map(
              (course) => {
                const courseInfo =
                  courseIcons[
                    Number(
                      course.course_id
                    )
                  ];

                if (!courseInfo) {
                  return null;
                }

                return (
                  <div
                    key={
                      course.course_id
                    }
                    className="profil-started-course"
                    title={
                      courseInfo.name
                    }
                  >
                    <img
                      src={
                        courseInfo.icon
                      }
                      alt={
                        courseInfo.name
                      }
                    />
                  </div>
                );
              }
            )}

          </div>

        </div>

        {/* CONTINUT PROFIL */}

        <div className="profil-main">

          <div className="line-profil-elements-separator" />

          {/* STATISTICI */}

          <div className="user-stats-elements-secondsection">

            <h2>Statistici</h2>

            <div className="profil-stats">

              <div className="profil-stat">
                <img
                  src={coinIcon}
                  alt="Monede"
                  className="profil-stat-icon"
                />

                <span className="profil-stat-value">
                  {formattedCoins}
                </span>

                <span className="profil-stat-label">
                  Monede
                </span>
              </div>

              <div className="profil-stat">
                <img
                  src={boltIcon}
                  alt="XP"
                  className="profil-stat-icon"
                />

                <span className="profil-stat-value profil-xp">
                  {formattedXp}
                </span>

                <span className="profil-stat-label">
                  XP
                </span>
              </div>

            </div>

          </div>

          {/* PRIETENI */}

      <FriendSuggestions
  onSeeAll={() =>
    setShowPeopleList(true)
  }
  onOpenUser={onOpenUser}
/>

      
{/*
  INVITA PRIETENI

  <div className="user-share-with-friends">

    <div className="user-share-content">

      <div className="user-share-icon">
        <img
          src={contiIcon}
          alt="Conti"
        />
      </div>

      <div className="user-share-text">

        <h3>Invita prieteni</h3>

        <p>
          Invata contabilitate impreuna
          cu prietenii tai si progresati
          impreuna pe ContaLearn!
        </p>

      </div>

    </div>

    <button
      type="button"
      className="user-share-button"
    >
      INVITA-TI PRIETENII
    </button>

  </div>
*/}


        </div>

      </div>
    </div>
  );
};

export default Profil;